
// axios
import axios from "axios";
// option
import { ClientOption } from "../../../config/clientOption";

export const GetCategoryProducts = async (queryKey: any) => {
    const { data: response } = await axios.get(`${process.env.REACT_APP_API_URL}categories/${queryKey.queryKey[1]}`, ClientOption);
    return response.data;
}